import { Mixer } from "./interface";
/** Export Constants only for pre-bundled usage **/
export var SAMPLE_RATE = 5 /* SampleRate */;
export var STATE = 0 /* State */;
export var COUNT = 256 /* Count */;
export var ACTIVE = 1 /* Active */;
export var RUNNING = 2 /* Running */;
export var STREAM = 4 /* Stream */;
export var LOOP = 4 /* Loop */;
export var MIXER = Mixer;
export var BUS = 268435456 /* Bus */;
export var VOICE = 805306368 /* Voice */;
export var BUFFER = 536870912 /* Buffer */;
export var BUS_MASTER = 268435456 /* Bus */ | 0;
export var BUS_SFX = 268435456 /* Bus */ | 1;
export var BUS_MUSIC = 268435456 /* Bus */ | 2;
export var BUS_SPEECH = 268435456 /* Bus */ | 3;
//# sourceMappingURL=static.js.map